import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PostBlob, Post } from '@/api/api-middleware';
import { apiPath } from '@/constants/defaultValues';
import { downloadFile, openFileInNewTab } from '@/helpers/Utils';

const initialState = {
  loading: false,
  error: '',
  AbsenteesReportData: [],
  DelayEarlyOutData: [],
  DetailedViolationsData: [],
};
export const GetAbsenteesReport = createAsyncThunk(
  'report/GetAbsenteesReport',
  async (params, thunkAPI) => {
    try {
      const url = `${apiPath}${'api/Reporting/AbsenteesReport'}`;
      if (params?.responseType !== 3) {
        const response = await PostBlob({
          url: url,
          data: params,
        });
        params?.responseType === 1
          ? openFileInNewTab(response)
          : downloadFile(response);
      } else {
        const response = await Post({
          url: url,
          data: params,
        });
        return response?.data;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const GetEarlyOutDelayReport = createAsyncThunk(
  'report/GetEarlyOutDelayReport',
  async (params, thunkAPI) => {
    try {
      const url = `${apiPath}${'api/Reporting/DelayEarlyOutReport'}`;
      if (params?.responseType !== 3) {
        const response = await PostBlob({
          url: url,
          data: params,
        });
        params?.responseType === 1
          ? openFileInNewTab(response)
          : downloadFile(response);
      } else {
        const response = await Post({
          url: url,
          data: params,
        });
        return response?.data;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const GetDetailedViolationsReport = createAsyncThunk(
  'report/GetDetailedViolationsReport',
  async (params, thunkAPI) => {
    try {
      const url = `${apiPath}${'api/Reporting/DetailedViolationsReport'}`;
      if (params?.responseType !== 3) {
        const response = await PostBlob({
          url: url,
          data: params,
        });
        params?.responseType === 1
          ? openFileInNewTab(response)
          : downloadFile(response);
      } else {
        const response = await Post({
          url: url,
          data: params,
        });
        return response?.data;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const violationReportSlice = createSlice({
  name: 'ViolationReport',
  initialState,
  reducers: {
    clearCurrentItem: (state) => {
      state.AttendanceReportData = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetAbsenteesReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAbsenteesReport.fulfilled, (state, action) => {
        state.loading = false;
        state.AbsenteesReportData = action.payload;
        state.error = '';
      })
      .addCase(GetAbsenteesReport.rejected, (state, action) => {
        state.loading = false;
        state.AbsenteesReportData = [];
        state.error = action.payload ?? 'An error occurred';
      });
    builder
      .addCase(GetEarlyOutDelayReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetEarlyOutDelayReport.fulfilled, (state, action) => {
        state.loading = false;
        state.DelayEarlyOutData = action.payload;
        state.error = '';
      })
      .addCase(GetEarlyOutDelayReport.rejected, (state, action) => {
        state.loading = false;
        state.DelayEarlyOutData = [];
        state.error = action.payload ?? 'An error occurred';
      });
    builder
      .addCase(GetDetailedViolationsReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetDetailedViolationsReport.fulfilled, (state, action) => {
        state.loading = false;
        state.DetailedViolationsData = action.payload;
        state.error = '';
      })
      .addCase(GetDetailedViolationsReport.rejected, (state, action) => {
        state.loading = false;
        state.DetailedViolationsData = [];
        state.error = action.payload ?? 'An error occurred';
      });
  },
});
export default violationReportSlice.reducer;
